// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"71da0bac","453":"4e840453","455":"40a041f3","484":"c55caa63","977":"42ab5b81"}[chunkId] + ".chunk.js";
};